// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"ModalWrapper___1-1Qj"};